import { ICategory, IDossierRequest, RequestStatus } from "../../types";
import PendingDossierCard from "./PendingDossierCard";
import { useEffect, useState } from "react";
import { getCategories, getDossiersRequests } from "../../API/dossier";
import { Center, Skeleton, Text } from "@chakra-ui/react";
import Pagination from "../../components/Pagination";


export interface PendingDossiersProps {}

const PendingDossiers: React.FC<PendingDossiersProps> = ({}) => {

    const [requests, setRequests] = useState<IDossierRequest[]>([]);
    const [categories, setCategories] = useState<ICategory[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [totalRequests, setTotalRequests] = useState<number>(0);
    const MAX_DOSSIERS_PER_PAGE = 5;
    useEffect(() => {
        getDossiersRequests(RequestStatus.Pending).then((resp) => {
            setRequests(resp.data.dossierRequests);
            setTotalRequests(resp.data.count);
            setLoading(false);
        });
        getCategories().then((resp) => {
            setCategories(resp.data.categories);
        });
    }, []);

    const handle_callback = (dossier_id:string) => {
        const newRequests = requests.filter((request: IDossierRequest) => request._id !== dossier_id);
        setRequests(newRequests);
    }

    
    const page_change = (selectedItem: { selected: number }) => {
        const page = selectedItem.selected;
        setLoading(true);
        getDossiersRequests(RequestStatus.Pending, MAX_DOSSIERS_PER_PAGE, page*MAX_DOSSIERS_PER_PAGE).then((resp) => {
            setRequests(resp.data.dossierRequests);
            setTotalRequests(resp.data.count);
            setLoading(false);
        });
    }

    return <>
        {!loading && requests.length > 0 && requests.map((request: IDossierRequest) => {
            // Get the categories that have their id in the request's categories array
            const requestCategories:ICategory[] = categories.filter((category: ICategory) => {
                return request.categories.includes(category._id);
            });
            return <PendingDossierCard key={request._id} dossier={request} categories={requestCategories} handle_callback={handle_callback} />
        })}
        {!loading && requests.length === 0 && 
        <Center>
            <Text fontSize={'md'}>Aucune demande en attente</Text>
        </Center>
        }
        {loading &&<>
            {[1, 2, 3].map((i) => {
                return <Skeleton key={i} height={"120px"} width={"100%"} mb={3} />
            })}
        </>}
        
        {totalRequests > MAX_DOSSIERS_PER_PAGE && <Center>
                <Pagination itemsPerPage={MAX_DOSSIERS_PER_PAGE} page_change_callback={page_change} totalCount={totalRequests}/>
        </Center>}
    </>
}

export default PendingDossiers;